// filepath: apps/web/src/features/admin/processes/ProcessesListPage.tsx
//
// FR-UI-BLD-1 / ISS-f4fa1b7b-258 - empty-state placeholder for the
// process-definition list page. The list-table functionality is
// tracked for a follow-up FR; this page ships with the route so the
// /admin/processes navigation works end-to-end.

import React from "react";
import { useTranslation } from "react-i18next";

export function ProcessesListPage(): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div
      className="processes-list-page"
      data-testid="processes-list-page"
      role="region"
      aria-label={t("admin.processes.list.aria")}
    >
      <h1 className="processes-list-page__title">
        {t("admin.processes.list.title")}
      </h1>
      <p
        className="processes-list-page__empty"
        data-testid="processes-list-page-empty"
      >
        {t("admin.processes.list.empty")}
      </p>
    </div>
  );
}
